import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';
import { companyNameIncludedOptions } from '../company/companyNameIncludedOptions';
import { monthOptions } from '../company/components/periodSelector/date';

export const initialPeriodValues = {
  fromMonth: monthOptions()[0],
  fromYear: 2010,
  toMonth: monthOptions()[0],
  toYear: 2020,
};

export const useCompanyNameFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();

  const formSchema = Yup.object().shape({
    companyName: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.mixed().required(),
        description: Yup.string().nullable(),
      }),
    ),
    companyNameIncluded: Yup.object().nullable(),
    companyNamePeriod: Yup.object().nullable(),
  });

  const onSearchChange = (currentValue) =>
    getFilterOptions({
      facet: 'companies',
      query: currentValue,
      sharedList,
      orderBy,
    }).then((res) => res.data);

  const onSubmit = ({ companyName, companyNameIncluded, companyNamePeriod }) => {
    const filters = { companyName };
    const removeFilters = [];

    if (companyName?.length > 0) {
      filters.companyNameIncluded = companyNameIncluded;

      if (companyNameIncluded?.value === 'specific_period') {
        filters.companyNamePeriod = companyNamePeriod;
      } else {
        // Remove companyNamePeriod when not in 'specific_period' mode
        removeFilters.push('companyNamePeriod');
      }
    } else {
      // When no companies are selected, remove the period filters
      removeFilters.push('companyNameIncluded', 'companyNamePeriod');
    }

    setFilters(filters, removeFilters.length > 0 ? { removeFilters } : {});
  };

  const getInitialValues = (value, companyNameIncluded, companyNamePeriod) => ({
    companyName: value || [],
    companyNameIncluded: companyNameIncluded || companyNameIncludedOptions[0],
    companyNamePeriod: companyNamePeriod || initialPeriodValues,
  });

  return {
    formSchema,
    onSearchChange,
    onSubmit,
    companyNameIncludedOptions,
    getInitialValues,
  };
};
